<template>
    <div class="box-wrap" :style="boxWrapStyleObj">
        <span class="border-left-top"></span>
        <span class="border-left-bottom"></span>
        <span class="border-right-top"></span>
        <span class="border-right-bottom"></span>
        <div class="statis-title bg1" ref="statisTitle">
            <span>{{ teaCourseware.name }} </span>
        </div>
        <div class="time-box"  v-if="id ==5 || $route.path== '/hsdataboard'" >
            <div class="time-type" @click="changeTimeType('1')" :class="timeType == '1' ? 'is-select' : ''">小学</div>
            <div class="line"></div>
            <div class="time-type" @click="changeTimeType('2')" :class="timeType == '2' ? 'is-select' : ''">初中</div>
            <div class="line"></div>
            <div class="time-type" @click="changeTimeType('3')" :class="timeType == '3' ? 'is-select' : ''">高中</div>
        </div>
        <div class="content" :style="contentStyleObj">
            <div :id="`chart-${id}`" style="width:100%;height:100%;position: absolute;"></div>
        </div>
    </div>
</template>
<script>
export default {
    name: "coursewareStatis",
    data() {
        return {
            timeType: 1,
            boxWrapStyleObj: {
                height: ''
            },
            contentStyleObj: {
                height: ''
            },
            rowStyleObj: {
                height: '',
                lineHeight: ''
            }
        }
    },
    props: {
        teaCourseware: {
            type: Array,
            default: function () {
                return []
            }
        },
        id: String,
        screenHeight: Number,
        titleHeight: Number,
        teaCoursewareCount: [String, Number]
    },
    watch: {
        teaCourseware(value) {
            if (value) {
                console.log('teaCourseware', value);
                this.initChart();
            }
        },
        'screenHeight': 'initBoxHeight',
        'titleHeight': 'initBoxHeight'
    },
    methods: {
        changeTimeType(type) {
            this.timeType = type
            this.initChart();
        },
        /**
         * 初始化box高度
         */
        initBoxHeight() {
            let winHeight = window.innerHeight;
            if (winHeight < 900) {
                winHeight = 938;
            }
            let boxWrapHeight = (winHeight - 128 - 10 - 30) / 3;
            let contentHeight = boxWrapHeight - this.$refs.statisTitle.offsetHeight - 20;
            this.boxWrapStyleObj.height = boxWrapHeight + 'px';
            this.contentStyleObj.height = contentHeight + 'px';
        },
        /**
  * 初始化教师课堂行为柱状图
  */
        initChart() {

            const option = {
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow'
                    }
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    top: '8%',
                    containLabel: true
                },
                xAxis: [
                    { 
                        name: " ",
                        type: 'category',
                        data: this.id == 5 || this.$route.path== '/hsdataboard'  ? this.teaCourseware.data[this.timeType - 1] : this.teaCourseware.data,
                        axisTick: {
                            // show: false,
                            alignWithLabel: true
                        },
                        axisLabel: {
                            interval: 0, // 设置为0以显示所有标签
                            textStyle: {
                                color: '#999999' // 设置为白色
                            },
                            formatter: function (val) {
                                return val.replace(/(.{3})/g, '$1\n');
                            }, // 横轴信息文字竖直显示
                        },

                    }
                ],
                yAxis: [
                    {
                        type: 'value',
                        axisLine: {
                            show: false // 不显示 y 轴线条
                        },
                        axisTick: {
                            show: false,
                            alignWithLabel: true
                        },
                        axisLabel: {
                            textStyle: {
                                color: '#999999' // 设置为白色
                            }
                        },
                        splitLine: {
                            lineStyle: {
                                color: '#999999' // 设置横线格栅颜色
                            }
                        },
                    },

                ],
                series: [
                    {
                        name: '数量',
                        type: 'bar',
                        barWidth: '60%',
                        data: this.id == 5 || this.$route.path== '/hsdataboard'  ? this.teaCourseware.value[this.timeType - 1] : this.teaCourseware.value,
                        label: {
                            show: true, // 显示数据
                            position: 'top', // 数据显示在柱子的顶部
                            color: '#60dbe3' // 数据的颜色设置为白色
                        },
                        itemStyle: {
                            color: new this.$echarts.graphic.LinearGradient(
                                0, 0, 0, 1,
                                [
                                    { offset: 0, color: '#60a1fb' }, // 柱图顶部颜色
                                    { offset: 1, color: '#3830d1' }  // 柱图底部颜色
                                ]
                            )
                        }
                    }
                ]
            };
            let dataChart = this.$echarts.init(document.getElementById(`chart-${this.id}`));
            dataChart.setOption(option);
            window.addEventListener('resize', function () {
                dataChart.resize();
            });
        }
    },
    mounted() {

    }
}
</script>

<style lang="scss" scoped>
@import "../../../style/databoard";

.bg1 {
    background-image: url("../../../assets/images/databoard/title-bg2.png");
}

.time-box {
    position: absolute;
    right: 10px;
    display: inline-flex;
    top: 10%;
    transform: translateY(-50%);
    height: 24px;
    justify-content: space-between;
    color: #359AFF;

    .line {
        width: 1px;
        height: 100%;
        background: linear-gradient(0deg, #061136 0%, #2E87E3 50%, #061136 100%);
        margin: 0 8px;
    }

    .time-type {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #359AFF;
        cursor: pointer;
    }

    .is-select {
        color: #38FFF3;
        border-bottom: 2px solid #38FFF3;
    }
}
</style>
